if (!customElements.get("mto-lightbox")) {
  const MIN_SCALE = 1;
  const MAX_SCALE = 8;
  const SCALE_STEP = 1.4;
  const PREVIEW_WIDTH = 2400;
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  const ICONS = {
    close:
      '<path d="M13.4 12l5.3-5.3a1 1 0 10-1.4-1.4L12 10.6 6.7 5.3a1 1 0 00-1.4 1.4L10.6 12l-5.3 5.3a1 1 0 101.4 1.4l5.3-5.3 5.3 5.3a1 1 0 001.4-1.4L13.4 12z"/>',
    prev: '<path d="M15.4 4.6a1 1 0 010 1.4L9.4 12l6 6a1 1 0 11-1.4 1.4l-6.7-6.7a1 1 0 010-1.4L14 4.6a1 1 0 011.4 0z"/>',
    next: '<path d="M8.6 4.6a1 1 0 000 1.4l6 6-6 6a1 1 0 101.4 1.4l6.7-6.7a1 1 0 000-1.4L10 4.6a1 1 0 00-1.4 0z"/>',
    zoomIn:
      '<path d="M10.5 3a7.5 7.5 0 015.9 12.1l4.3 4.3a1 1 0 01-1.4 1.4l-4.3-4.3A7.5 7.5 0 1110.5 3zm0 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 2a1 1 0 011 1v1.5H13a1 1 0 010 2h-1.5V13a1 1 0 01-2 0v-1.5H8a1 1 0 010-2h1.5V8a1 1 0 011-1z"/>',
    zoomOut:
      '<path d="M10.5 3a7.5 7.5 0 015.9 12.1l4.3 4.3a1 1 0 01-1.4 1.4l-4.3-4.3A7.5 7.5 0 1110.5 3zm0 2a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM8 9.5h5a1 1 0 010 2H8a1 1 0 010-2z"/>',
    rotateLeft:
      '<path d="M8 5V2.5L4.5 6 8 9.5V7a6 6 0 11-6 6 1 1 0 10-2 0 8 8 0 108-8z"/><path d="M11 12h8a1 1 0 011 1v7a1 1 0 01-1 1h-8a1 1 0 01-1-1v-7a1 1 0 011-1z" fill="none" stroke="currentColor" stroke-width="2"/>',
    rotateRight:
      '<path d="M16 5V2.5L19.5 6 16 9.5V7a6 6 0 106 6 1 1 0 112 0 8 8 0 11-8-8z"/><path d="M5 12h8a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1z" fill="none" stroke="currentColor" stroke-width="2"/>',
    flipX:
      '<path d="M12 2a1 1 0 011 1v18a1 1 0 01-2 0V3a1 1 0 011-1zM9 6v12H4a1 1 0 01-.8-1.6l4-5.4a1 1 0 000-1.2l-4-5.4A1 1 0 014 6h5zm6 0h5a1 1 0 01.8 1.6l-4 5.4a1 1 0 000 1.2l4 5.4A1 1 0 0120 18h-5V6z" fill-opacity=".55"/>',
    flipY:
      '<path d="M2 12a1 1 0 011-1h18a1 1 0 010 2H3a1 1 0 01-1-1zM6 9h12V4a1 1 0 00-1.6-.8l-5.4 4a1 1 0 01-1.2 0l-5.4-4A1 1 0 004 4v5zm0 6v5a1 1 0 001.6.8l5.4-4a1 1 0 011.2 0l5.4 4A1 1 0 0020 20v-5H6z" fill-opacity=".55"/>',
  };

  const icon = (name) =>
    `<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">${ICONS[name]}</svg>`;

  class MtoLightbox extends HTMLElement {
    connectedCallback() {
      if (this.built) return;
      this.built = true;

      this.images = [];
      this.index = 0;
      this.setAttribute("role", "dialog");
      this.setAttribute("aria-modal", "true");
      this.setAttribute("tabindex", "-1");
      this.hidden = true;

      this.innerHTML = `
        <div class="mto-lightbox__mask"></div>
        <div class="mto-lightbox__stage">
          <img class="mto-lightbox__img" alt="">
        </div>
        <button type="button" class="mto-lightbox__close" data-act="close">${icon(
          "close"
        )}</button>
        <button type="button" class="mto-lightbox__switch mto-lightbox__switch--prev" data-act="prev">${icon(
          "prev"
        )}</button>
        <button type="button" class="mto-lightbox__switch mto-lightbox__switch--next" data-act="next">${icon(
          "next"
        )}</button>
        <div class="mto-lightbox__toolbar">
          <button type="button" class="mto-lightbox__btn" data-act="flipX">${icon(
            "flipX"
          )}</button>
          <button type="button" class="mto-lightbox__btn" data-act="flipY">${icon(
            "flipY"
          )}</button>
          <button type="button" class="mto-lightbox__btn" data-act="rotateLeft">${icon(
            "rotateLeft"
          )}</button>
          <button type="button" class="mto-lightbox__btn" data-act="rotateRight">${icon(
            "rotateRight"
          )}</button>
          <button type="button" class="mto-lightbox__btn" data-act="zoomOut">${icon(
            "zoomOut"
          )}</button>
          <button type="button" class="mto-lightbox__btn" data-act="zoomIn">${icon(
            "zoomIn"
          )}</button>
        </div>`;

      this.img = this.querySelector(".mto-lightbox__img");
      this.prevBtn = this.querySelector('[data-act="prev"]');
      this.nextBtn = this.querySelector('[data-act="next"]');
      this.zoomOutBtn = this.querySelector('[data-act="zoomOut"]');
      this.zoomInBtn = this.querySelector('[data-act="zoomIn"]');

      this.addEventListener("click", this.handleClick.bind(this));
      this.addEventListener("wheel", this.handleWheel.bind(this), {
        passive: false,
      });
      this.addEventListener("pointerdown", this.handlePointerDown.bind(this));
      this.boundKeydown = this.handleKeydown.bind(this);
      this.boundFocusIn = this.handleFocusIn.bind(this);
    }

    open(images, index = 0) {
      if (!images || images.length === 0) return;

      this.images = images;
      this.lastFocused = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add("mto-lightbox-open");
      document.addEventListener("keydown", this.boundKeydown);
      document.addEventListener("focusin", this.boundFocusIn);

      this.show(index);
      requestAnimationFrame(() => this.focus());
    }

    close() {
      this.hidden = true;
      document.documentElement.classList.remove("mto-lightbox-open");
      document.removeEventListener("keydown", this.boundKeydown);
      document.removeEventListener("focusin", this.boundFocusIn);
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
    }

    getFocusableEls() {
      return Array.from(this.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
        (el) => !el.hidden && el.offsetParent !== null
      );
    }

    trapTab(evt) {
      const focusable = this.getFocusableEls();
      if (focusable.length === 0) {
        evt.preventDefault();
        this.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (evt.shiftKey && (active === first || active === this || !this.contains(active))) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && (active === last || !this.contains(active))) {
        evt.preventDefault();
        first.focus();
      }
    }

    handleFocusIn(evt) {
      if (this.hidden || this.contains(evt.target)) return;
      const focusable = this.getFocusableEls();
      (focusable[0] || this).focus();
    }

    show(index) {
      const total = this.images.length;
      this.index = (index + total) % total;
      const image = this.images[this.index];

      this.img.src = `${image.u}${image.u.includes("?") ? "&" : "?"}width=${PREVIEW_WIDTH}`;
      this.img.alt = image.a || "";
      this.resetTransform();

      const single = total < 2;
      this.prevBtn.hidden = single;
      this.nextBtn.hidden = single;
    }

    resetTransform() {
      this.scale = 1;
      this.rotate = 0;
      this.flipXValue = 1;
      this.flipYValue = 1;
      this.panX = 0;
      this.panY = 0;
      this.applyTransform();
    }

    applyTransform() {
      this.img.style.transform = `translate3d(${this.panX}px, ${this.panY}px, 0) scale3d(${
        this.scale * this.flipXValue
      }, ${this.scale * this.flipYValue}, 1) rotate(${this.rotate}deg)`;
      this.img.classList.toggle("is-zoomed", this.scale > 1);
      this.zoomOutBtn.disabled = this.scale <= MIN_SCALE;
      this.zoomInBtn.disabled = this.scale >= MAX_SCALE;
    }

    zoomBy(factor) {
      const next = Math.min(MAX_SCALE, Math.max(MIN_SCALE, this.scale * factor));
      if (next === this.scale) return;
      this.scale = next;
      if (this.scale === MIN_SCALE) {
        this.panX = 0;
        this.panY = 0;
      }
      this.applyTransform();
    }

    run(action) {
      switch (action) {
        case "close":
          this.close();
          break;
        case "prev":
          this.show(this.index - 1);
          break;
        case "next":
          this.show(this.index + 1);
          break;
        case "zoomIn":
          this.zoomBy(SCALE_STEP);
          break;
        case "zoomOut":
          this.zoomBy(1 / SCALE_STEP);
          break;
        case "rotateLeft":
          this.rotate -= 90;
          this.applyTransform();
          break;
        case "rotateRight":
          this.rotate += 90;
          this.applyTransform();
          break;
        case "flipX":
          this.flipXValue *= -1;
          this.applyTransform();
          break;
        case "flipY":
          this.flipYValue *= -1;
          this.applyTransform();
          break;
        default:
          break;
      }
    }

    handleClick(evt) {
      const btn = evt.target.closest("[data-act]");
      if (btn) {
        evt.preventDefault();
        this.run(btn.dataset.act);
        return;
      }
      if (!evt.target.closest(".mto-lightbox__img")) this.close();
    }

    handleWheel(evt) {
      evt.preventDefault();
      this.zoomBy(evt.deltaY < 0 ? SCALE_STEP : 1 / SCALE_STEP);
    }

    handlePointerDown(evt) {
      if (this.scale <= MIN_SCALE) return;
      if (evt.target.closest("[data-act]")) return;

      evt.preventDefault();
      const startX = evt.clientX - this.panX;
      const startY = evt.clientY - this.panY;

      const move = (e) => {
        this.panX = e.clientX - startX;
        this.panY = e.clientY - startY;
        this.applyTransform();
      };
      const up = () => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
      };

      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", up);
    }

    handleKeydown(evt) {
      switch (evt.key) {
        case "Tab":
          this.trapTab(evt);
          break;
        case "Escape":
          this.close();
          break;
        case "ArrowLeft":
          this.show(this.index - 1);
          break;
        case "ArrowRight":
          this.show(this.index + 1);
          break;
        case "+":
        case "=":
          this.zoomBy(SCALE_STEP);
          break;
        case "-":
          this.zoomBy(1 / SCALE_STEP);
          break;
        default:
          break;
      }
    }
  }

  customElements.define("mto-lightbox", MtoLightbox);
}
